import { render, staticRenderFns } from "./TemplatePortraitFrame.vue?vue&type=template&id=c2c8698a&scoped=true&"
import script from "./TemplatePortraitFrame.vue?vue&type=script&lang=js&"
export * from "./TemplatePortraitFrame.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePortraitFrame.vue?vue&type=style&index=0&id=c2c8698a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c8698a",
  null
  
)

export default component.exports